import { Switch } from "react-router-dom";
import HomePage from "../pages/home";
import RouteWithLayout from "../hoc/RouteWithLayout";
import PrivateLayout from "../layout/privateLayout";
import Team from "../pages/team";
import Labels from "../pages/labels";
import Services from "../pages/services";
import ReleasesDesc from "../pages/releasesDescription";
import ReleasesPage from "../pages/releases";
import Login from "../pages/login";
import ForgotPassword from "../pages/forgotPassword";
import NewPassword from "../pages/confirmPassword";
import AudioPlayers from "../components/audioPlayer";
import Setting from "../pages/setting";
import Cart from "../pages/cart";
import TermsAndCondition from "../components/termsAndCondition";
import PrivacyPolicy from "../components/PrivacyPolicy";
import SearchItem from "../pages/SearchItem";
import ResetPassword from "../pages/resetPassword";
import { isCart } from "../utils/string";

const AppRouter = () => {
  return (
    <Switch>
      <RouteWithLayout
        component={HomePage}
        exact
        layout={PrivateLayout}
        path="/"
      />
      <RouteWithLayout
        component={Team}
        exact
        layout={PrivateLayout}
        path="/contact"
      />
      <RouteWithLayout
        component={Labels}
        exact
        layout={PrivateLayout}
        path="/labels"
      />
      <RouteWithLayout
        component={Services}
        exact
        layout={PrivateLayout}
        path="/services"
      />
      <RouteWithLayout
        component={ReleasesDesc}
        exact
        layout={PrivateLayout}
        path="/products/:type/:catNo"
      />
      <RouteWithLayout
        component={ReleasesPage}
        exact
        layout={PrivateLayout}
        path="/releases"
      />
      <RouteWithLayout
        component={Login}
        exact
        layout={PrivateLayout}
        path="/login"
      />
      <RouteWithLayout
        component={ForgotPassword}
        exact
        layout={PrivateLayout}
        path="/forgotPassword"
      />
       <RouteWithLayout
        component={ResetPassword}
        exact
        layout={PrivateLayout}
        path="/reset-password"
      />
      <RouteWithLayout
        component={NewPassword}
        exact
        layout={PrivateLayout}
        path="/newPassword"
      />
      <RouteWithLayout
        component={AudioPlayers}
        exact
        layout={PrivateLayout}
        path="/audioPlayer"
      />
      <RouteWithLayout
        component={Setting}
        exact
        layout={PrivateLayout}
        path="/profile"
      />
      {
        isCart && (
          <RouteWithLayout
          component={Cart}
          exact
          layout={PrivateLayout}
          path="/cart"
        />
        )
      }

      <RouteWithLayout
        component={TermsAndCondition}
        exact
        layout={PrivateLayout}
        path="/terms"
      />
      <RouteWithLayout
        component={PrivacyPolicy}
        exact
        layout={PrivateLayout}
        path="/policy"
      />
      <RouteWithLayout
        component={SearchItem}
        exact
        layout={PrivateLayout}
        path="/search"
      />
    </Switch>
  );
};

export default AppRouter;
